
define('text!templates/components/distributor_role/distributor_role.html',[],function () { return '<td data-cell="name">\n    <a href="/personal-roles/<%= id %>"><%= role_name %> </a>\n</td>\n\n\n';});

